<template>
  <div class="container-fluid">
    <nav class="navbar">
      <div class="mx-auto"><a class="navbar-brand">登入</a></div>
    </nav>
    <div class="row">
      <div class="col col-11 col-md-5 col-xl-3">
        <div class="input-group">
          <span>手機號碼：</span>
          <input type="text" class="form-control" v-model="phone">
        </div>
        <div class="input-group">
          <span>密碼：</span>
          <input type="password" class="form-control" v-model="password">
        </div>
        <div class="loginButton">
          <button class="btn btn-lg btn-primary" @click="Login(this.$data.phone, this.$data.password)">
            <i class="fa-solid fa-right-to-bracket"></i>登入
          </button>
          <div class="ForgetPassword" @click="ForgetPassword()">忘記密碼嗎？請點此</div>
          <div class="RegisterGuide" @click="Register()">首次使用請先註冊</div>
        </div>
      </div>
    </div>
    <div class="row Footer">
      <div class="col">
        <button class="btn" @click="Home()">
          <i class="fas fa-home"></i><br><span>首頁</span>
        </button>
      </div>
      <div class="col">
        <button class="btn" @click="Register()">
          <i class="fa-solid fa-address-card"></i><br><span>註冊</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from '@/mixins/Auth'
import { Groupbuy } from '@/mixins/Groupbuy'

export default {
  name: "Login",
  mixins: [Auth, Groupbuy],
  data() {
    return {
      phone: null,  // 手機號碼
      password: null, // 密碼
    }
  },
  methods: {
    /* 前往首頁頁面 */
    Home: function() {
      this.$router.push({ name: `Home` })
    },
    /* 前往註冊頁面 */
    Register: function() {
      this.$router.push({ name: `Register` })
    },
    /* 前往忘記密碼頁面 */
    ForgetPassword: function() {
      this.$router.push({ name: `ForgetPassword` })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-fluid, .row, .col {
  margin: 0px;
  padding: 0px;
  justify-content: center;
  > .navbar {
    margin-bottom: 30px;
    padding: 0px 20px;
    height: 8vh;
    background-color: #5599FF;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 900;
    > .mx-auto {
      > .navbar-brand {
        margin: 0px;
        color: #FFFFFF;
      }
    }
  }
  > .input-group {
    > span {
      text-align: right;
      width: 100px;
      line-height: 38px;
      margin-right: 10px;
      font-weight: bold;
    }
    > input[type=text] {
      width: 50% !important;
    }
    > button {
      margin-left: 10px !important;
      border-radius: 0.25rem !important;
    }
  }
  > .input-group:not(:last-child) {
    margin-bottom: 20px;
  }
  > .loginButton {
    margin-top: 40px;
    padding-bottom: 90px;
    text-align: center;
    > button {
      > svg {
        margin-right: 3px;
      }
      font-weight: bold;
    }
    .ForgetPassword {
      margin-top: 20px;
      font-weight: bold;
    }
    .RegisterGuide {
      margin: 180px auto 0;
      width: 100%;
      max-width: 320px;
      padding: 10px 14px;
      border: 1px solid #2f6fed;
      border-radius: 10px;
      background-color: #eef4ff;
      color: #1f4fbf;
      line-height: 1.4;
      text-align: center;
      font-weight: bold;
      cursor: pointer;
    }
  }
  > .Footer {
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    height: 70px;
    background-color: #5599FF;
    > .col {
      > .btn {
        border: 0px;
        background-color: #5599FF;
        box-shadow: 0px 0px 0px 0px;
        color: #FFFFFF;
        font-size: 20px;
        font-weight: 900;
        > .fas {
          margin-bottom: 3px;
          font-size: 24px;
        }
      }
    }
  }
}
</style>
